const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'
const SystemInfo = 'SYSTEM_INFO'
const TenantIdKey = 'TENANT_ID'
const UserNameKey = 'USER_NAME'

// ========== Token 相关 ==========

export function getAccessToken() {
    return uni.getStorageSync(AccessTokenKey)
}

export function getRefreshToken() {
    return uni.getStorageSync(RefreshTokenKey)
}

export function getUserNameKey() {
    return uni.getStorageSync(UserNameKey)
}

export function setToken(token) {
    uni.setStorageSync(AccessTokenKey, token.accessToken)
    uni.setStorageSync(RefreshTokenKey, token.refreshToken)
    uni.setStorageSync(UserNameKey, token.name)
}

// ========== 设备信息 ==========

export function setSystemInfo(data) {
    uni.setStorageSync(SystemInfo, data)
}

export function getSystemInfo() {
    return uni.getStorageSync(SystemInfo)
}

// ========== 租户相关 ==========

export const getTenantId = () => {
    return uni.getStorageSync(TenantIdKey) || '1'
}

export const setTenantId = (username) => {
    uni.setStorageSync(TenantIdKey, username)
}

export function removeToken() {
    uni.removeStorageSync(AccessTokenKey)
    uni.removeStorageSync(RefreshTokenKey)
    // uni.removeStorageSync(TenantIdKey)
}


export function isLogin() {
    return !!getAccessToken()
}